import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ade8c70c9e137dbd598f448fdaa04b088b from "./generated-93793bc3-dcdd-48d6-8a7f-fc5c50669679.json";

import a90043284964ede1753a764421e9d6819b from "./generated-c11f34a3-a879-4ed3-97eb-af57522c3e10.json";

import aa7ec4f336e481c925364da98657abb3eb from "./generated-71ad1905-5373-42b3-b0fa-cc9f8835fa29.json";

import abd54d7bdacd50cc99fda3b6a5f85a656b from "./generated-78d3b3ef-2b46-4f4b-a444-2717e0521b46.json";

import a5d7d1d32bfcfb13db8dc242839acd115b from "./generated-8465437a-eac2-4025-8909-762ff13fc28d.json";

import a947376edbc01a8b8db74da212a1d7ca4b from "./generated-6eee0006-30da-4ed1-a5ee-1ada3ef981bd.json";

import a237a8e52a5c5be9e724782ebb124cae3b from "./generated-295a74a3-26af-448d-a73e-025ea1430771.json";

import a5d53c2ecc89a7e7de8c99bc44a8182aeb from "./generated-16112612-fc22-4a86-a3d3-41e2fda53a07.json";

import a08fc7300a824f0983e130ef1e05102d7b from "./generated-705139d4-21c6-4874-8f76-75a33277e19d.json";

import a7679fa8c617f4b2686ceecdecca788ecb from "./generated-f895c85d-8625-43fc-9ebf-d22b5202c722.json";

import acbdda3eae304cf8b6daadae84933e494b from "./generated-56046966-a2ab-47c0-b0de-9637f581ed55.json";

import afee5543bd1ea8f8793ba9c40ccb3c38ab from "./generated-636adafe-ec3a-4776-9018-eadc999a35c9.json";

import a68373b47a0f8f0e03dd76c13efd3694bb from "./generated-d7adb723-282c-4f49-b07c-92873e553118.json";

import a25e12dccfb7b5391f519f5c8ea447297b from "./generated-58a36c51-bdad-433f-b718-102c7b59631d.json";

import aa1a7d83327f669acd885308e83850722b from "./generated-88cd2b45-3fcf-49b7-870b-a5460be80db5.json";

import ab85ddc9c62f01c78e168f910afca1ee2b from "./generated-aadfa92b-4bba-4ca0-bdbf-dec4597eddf7.json";

import a7b6555fe0c1a78f518bc4c7021f24d4eb from "./generated-fb3ab91c-05de-49ac-a987-5775e7fbf398.json";

import a114a33f1c783381aab6f61e89cf41584b from "./generated-52825667-28c3-46bd-9d04-a8fb37473743.json";

import af7b62ffb72a1c74f76419dc7605268f9b from "./generated-a3092bb9-b53c-4484-8c3b-7f52a5945a8a.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ade8c70c9e137dbd598f448fdaa04b088b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a90043284964ede1753a764421e9d6819b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(aa7ec4f336e481c925364da98657abb3eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(abd54d7bdacd50cc99fda3b6a5f85a656b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a5d7d1d32bfcfb13db8dc242839acd115b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a947376edbc01a8b8db74da212a1d7ca4b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a237a8e52a5c5be9e724782ebb124cae3b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a5d53c2ecc89a7e7de8c99bc44a8182aeb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a08fc7300a824f0983e130ef1e05102d7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a7679fa8c617f4b2686ceecdecca788ecb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(acbdda3eae304cf8b6daadae84933e494b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(afee5543bd1ea8f8793ba9c40ccb3c38ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a68373b47a0f8f0e03dd76c13efd3694bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a25e12dccfb7b5391f519f5c8ea447297b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aa1a7d83327f669acd885308e83850722b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ab85ddc9c62f01c78e168f910afca1ee2b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a7b6555fe0c1a78f518bc4c7021f24d4eb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a114a33f1c783381aab6f61e89cf41584b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(af7b62ffb72a1c74f76419dc7605268f9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a7b6555fe0c1a78f518bc4c7021f24d4eb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */